export enum PlanningTab {
  PROGRESS,
  PLAN,
  //TIMELINE,
}
